import { useLayoutEffect } from 'react';
import { debounce } from 'lodash';

function useResize(ref, callback) {
  var _ref$current;

  var _ref = (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect()) || {
    right: null,
    left: null
  },
      right = _ref.right,
      left = _ref.left;

  var handleResize = debounce(callback, 300);
  useLayoutEffect(function () {
    handleResize();
  }, [right, left]);
}

export { useResize };
//# sourceMappingURL=useResize.js.map
